import React from 'react';
import './CSS/Toolkit.css';

// Import toolkit icons
import toolkit1 from '../assets/icons/toolkit/toolkit1.png';
import toolkit2 from '../assets/icons/toolkit/toolkit2.png';
import toolkit3 from '../assets/icons/toolkit/toolkit3.png';

const Toolkit = () => {
  const features = [
    {
      icon: toolkit1,
      title: "Built on Service",
      description: "We launched in 2011 with a single goal — to provide tech repair services without the hassle. That hands-on, local-first attitude still drives us today."
    },
    {
      icon: toolkit2,
      title: "Expanded with Purpose",
      description: "From fixing phones to stringing rackets and supporting small businesses, our offerings grew as our customers' needs grew."
    },
    {
      icon: toolkit3,
      title: "Rooted in London",
      description: "What started in Notting Hill now serves across multiple neighbourhoods. Each location carries our signature fixINN care and personal touch."
    }
  ];

  return (
    <section className="toolkit-section">
      <div className="container">
        <div className="toolkit-content">
          {/* Left Column - 55% */}
          <div className="toolkit-left">
            <div className="toolkit-header">
              <h2 className="toolkit-title">
                Started with a toolkit and a mission — <span className="text-primary">now trusted across London.</span>
              </h2>
              <p className="toolkit-description">
                From tech repairs to personal coaching, fixINN offers reliable, local services designed to make your life easier — all under one roof.
              </p>
            </div>
          </div>

          {/* Right Column - 45% */}
          <div className="toolkit-right">
            <div className="toolkit-features">
              {features.map((feature, index) => (
                <div key={index} className="toolkit-feature-item">
                  <div className="toolkit-feature-icon">
                    <img src={feature.icon} alt={feature.title} />
                  </div>
                  <div className="toolkit-feature-content">
                    <h3 className="toolkit-feature-title">{feature.title}</h3>
                    <p className="toolkit-feature-description">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Toolkit;